var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24951 11L12.2078 6.0625L11.1453 5L7.24951 8.875L5.47868 7.125L4.41618 8.1875L7.24951 11ZM8.31201 16C7.21479 16 6.18007 15.7917 5.20785 15.375C4.23562 14.9583 3.38493 14.3854 2.65576 13.6562C1.92659 12.9271 1.35368 12.0764 0.937012 11.1042C0.520345 10.1319 0.312012 9.09722 0.312012 8C0.312012 6.88889 0.520345 5.85069 0.937012 4.88542C1.35368 3.92014 1.92659 3.07292 2.65576 2.34375C3.38493 1.61458 4.23562 1.04167 5.20785 0.625C6.18007 0.208333 7.21479 0 8.31201 0C9.42312 0 10.4613 0.208333 11.4266 0.625C12.3919 1.04167 13.2391 1.61458 13.9683 2.34375C14.6974 3.07292 15.2703 3.92014 15.687 4.88542C16.1037 5.85069 16.312 6.88889 16.312 8C16.312 9.09722 16.1037 10.1319 15.687 11.1042C15.2703 12.0764 14.6974 12.9271 13.9683 13.6562C13.2391 14.3854 12.3919 14.9583 11.4266 15.375C10.4613 15.7917 9.42312 16 8.31201 16ZM8.31201 14.5C10.1176 14.5 11.6523 13.8681 12.9162 12.6042C14.1801 11.3403 14.812 9.80556 14.812 8C14.812 6.19444 14.1801 4.65972 12.9162 3.39583C11.6523 2.13194 10.1176 1.5 8.31201 1.5C6.50646 1.5 4.97173 2.13194 3.70785 3.39583C2.44396 4.65972 1.81201 6.19444 1.81201 8C1.81201 9.80556 2.44396 11.3403 3.70785 12.6042C4.97173 13.8681 6.50646 14.5 8.31201 14.5Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_Icon.78219f8a9c82fe326bd08c5411392ea9.svg";
export { ForwardRef as ReactComponent };